import { useRollbar } from './useRollbar.js';
import 'react';
import './Provider.js';
import './_rollupPluginBabelHelpers-e84dd01a.js';
import 'prop-types';
import 'rollbar';
import './tiny-invariant.esm-a43f84cc.js';

function useRollbarConfiguration(config) {
  var rollbar = useRollbar();
  rollbar.configure(config);
}

export { useRollbarConfiguration };
//# sourceMappingURL=useRollbarConfiguration.js.map
